import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',
  breakpoints: {
    values: { xs: 0, sm: 641, md: 901, lg: 1101, xl: 1536 },
  },
  typography: {
    fontFamily: 'Heebo, Arial, sans-serif',
    button: { fontWeight: 700, textTransform: 'none' },
  },
  shape: { borderRadius: 5 },
  palette: {
    mode: 'light',
    primary: { main: '#5b5bd6' },
    border: {
      main: '#e4e4e4',
    },
    background: {
      default: '#f6f7fb',
      paper: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        size: 'small',
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          height: 32,
          minHeight: 32,
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiOutlinedInput: {
      defaultProps: { size: 'small' },
      styleOverrides: {
        root: { minHeight: 40 },
        inputSizeSmall: {
          paddingTop: 8.5,
          paddingBottom: 8.5,
        },
      },
    },
    MuiFormControl: {
      defaultProps: { size: 'small', fullWidth: true },
    },
    MuiSelect: { defaultProps: { size: 'small' } },
    MuiCheckbox: { defaultProps: { size: 'small' } },
    MuiRadio: { defaultProps: { size: 'small' } },
    MuiSwitch: { defaultProps: { size: 'small' } },
    MuiTableCell: { defaultProps: { size: 'small' } },
    MuiDialog: { defaultProps: { fullWidth: true } },
  },
});

export default theme;
